var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesajust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0011 18.3279C14.604 18.3279 18.3354 14.5981 18.3354 9.99709C18.3354 5.3961 14.604 1.66626 10.0011 1.66626C5.39816 1.66626 1.66675 5.3961 1.66675 9.99709C1.66675 14.5981 5.39816 18.3279 10.0011 18.3279Z",
    stroke: "currentColor",
    strokeWidth: 1.66617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0011 14.9955C12.7628 14.9955 15.0017 12.7576 15.0017 9.99703C15.0017 7.23644 12.7628 4.99854 10.0011 4.99854C7.23933 4.99854 5.00049 7.23644 5.00049 9.99703C5.00049 12.7576 7.23933 14.9955 10.0011 14.9955Z",
    stroke: "currentColor",
    strokeWidth: 1.66617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0011 11.6631C10.9217 11.6631 11.668 10.9172 11.668 9.99698C11.668 9.07678 10.9217 8.33081 10.0011 8.33081C9.08051 8.33081 8.33423 9.07678 8.33423 9.99698C8.33423 10.9172 9.08051 11.6631 10.0011 11.6631Z",
    stroke: "currentColor",
    strokeWidth: 1.66617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0024,
    height: 19.994,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesajust);
export default __webpack_public_path__ + "static/media/desajust.7945f7624010670fbdb817f0ec57f2d7.svg";
export { ForwardRef as ReactComponent };